import { createIcon } from '../createIcon';
import { ReactComponent as IconChevronDown } from '../svg/chevron-down.svg';

export default createIcon(IconChevronDown);
